import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { PropTypes } from 'prop-types';
import treeChanges from 'tree-changes';
import moment from 'moment';

import {
  AuditOutlined,
  EditOutlined,
  PrinterOutlined,
  DownloadOutlined,
  ReloadOutlined
} from '@ant-design/icons';

import { Row, Col, Card, Table, Button, Popconfirm } from 'antd';

import AntDesignTable from '../../Components/AntDesignTable';
import PackListIndexActions from '../../Stores/PackListIndex/Actions';

class PackListIndexScreen extends React.PureComponent {
  constructor() {
    super();

    this.useOnTableChange = this.useOnTableChange.bind(this);

    this.handleSearch = this.handleSearch.bind(this);
    this.handleReset = this.handleReset.bind(this);
    this.getDocumentColumns = this.getDocumentColumns.bind(this);
  }

  componentDidMount() {
    const { curSiteFlowId, resetTimestamp } = this.props;

    if (curSiteFlowId > 0) {
      resetTimestamp();
    }
  }

  componentDidUpdate(prevProps) {
    const {
      curSiteFlowId,
      resetTimestamp,
      fetchPackListIndex,
      currentPage,
      sorts,
      filters,
      pageSize
    } = this.props;

    const { changed } = treeChanges(prevProps, this.props);

    if (changed('curSiteFlowId')) {
      resetTimestamp();
    }

    if (changed('timestamp')) {
      if (curSiteFlowId > 0) {
        fetchPackListIndex(currentPage, sorts, filters, pageSize);
      }
    }
  }

  componentWillUnmount() {}

  handleSearch(selectedKeys, confirm) {
    // eslint-disable-next-line no-unused-vars
    const { intl } = this.props;

    confirm();
  }

  handleReset(clearFilters) {
    // eslint-disable-next-line no-unused-vars
    const { intl } = this.props;

    clearFilters();
  }

  getDocumentColumns() {
    const {
      intl,
      sorts,
      filters,
      goToPrint,
      excelOutbOrdDtls,
      goToDocument,
      goToAudit,
      documents
    } = this.props;
    const packListHdrCaseQty01 = documents[0] ? documents[0].case_qty_01_title : '';
    const packListHdrCaseQty02 = documents[0] ? documents[0].case_qty_02_title : '';
    const packListHdrCaseQty03 = documents[0] ? documents[0].case_qty_03_title : '';
    const packListHdrCaseQty04 = documents[0] ? documents[0].case_qty_04_title : '';
    const packListHdrCaseQty05 = documents[0] ? documents[0].case_qty_05_title : '';
    const packListHdrCaseQty06 = documents[0] ? documents[0].case_qty_06_title : '';
    const packListHdrCaseQty07 = documents[0] ? documents[0].case_qty_07_title : '';
    const packListHdrCaseQty08 = documents[0] ? documents[0].case_qty_08_title : '';
    const packListHdrCaseQty09 = documents[0] ? documents[0].case_qty_09_title : '';
    const packListHdrCaseQty10 = documents[0] ? documents[0].case_qty_10_title : '';

    return [
      {
        width: 100,
        align: 'left',
        title: intl.formatMessage({ id: 'doc_code' }),
        // sort field
        dataIndex: 'doc_code',
        ...AntDesignTable.getColumnSortProps(sorts, 'doc_code'),
        // filter field
        key: 'doc_code',
        ...AntDesignTable.getColumnSearchInputProps(
          filters,
          intl.formatMessage({ id: 'doc_code' }),
          'doc_code',
          this.handleSearch,
          this.handleReset
        ),
        render: (text, record) => <>{record.doc_code}</>
      },
      {
        width: 100,
        align: 'left',
        title: intl.formatMessage({ id: 'doc_date' }),
        // sort field
        dataIndex: 'doc_date',
        ...AntDesignTable.getColumnSortProps(sorts, 'doc_date'),
        // filter field
        key: 'doc_date',
        ...AntDesignTable.getColumnSearchDateProps(
          filters,
          intl.formatMessage({ id: 'doc_date' }),
          'doc_date',
          this.handleSearch,
          this.handleReset
        ),
        render: (text, record) => <>{moment(record.doc_date).format('YYYY-MM-DD')}</>
      },
      {
        width: 100,
        align: 'left',
        title: intl.formatMessage({ id: 'doc_status' }),
        // sort field
        dataIndex: 'doc_status',
        ...AntDesignTable.getColumnSortProps(sorts, 'doc_status'),
        // filter field
        ...AntDesignTable.getColumnSearchDocStatusProps(filters, 'doc_status'),
        render: (text, record) => <>{record.str_doc_status}</>
      },
      {
        width: 90,
        align: 'left',
        title: intl.formatMessage({ id: 'to_storage_bin' }),
        // sort field
        dataIndex: 'to_storage_bin_code',
        // filter field
        key: 'to_storage_bin',
        ...AntDesignTable.getColumnSearchInputProps(
          filters,
          intl.formatMessage({ id: 'to_storage_bin' }),
          'to_storage_bin',
          this.handleSearch,
          this.handleReset
        ),
        render: (text, record) => <b>{record.to_storage_bin_code}</b>
      },
      {
        width: 90,
        align: 'left',
        title: intl.formatMessage({ id: 'area' }),
        // sort field
        dataIndex: 'delivery_point_area_code',
        ...AntDesignTable.getColumnSortProps(sorts, 'delivery_point_area_code'),
        // filter field
        key: 'delivery_point_area',
        ...AntDesignTable.getColumnSearchInputProps(
          filters,
          intl.formatMessage({ id: 'area' }),
          'delivery_point_area',
          this.handleSearch,
          this.handleReset
        ),
        render: (text, record) => (
          <>
            <div>
              <b>{record.area.code}</b>
              <br />
              {record.area.desc_01}
            </div>
          </>
        )
      },
      {
        width: 120,
        align: 'left',
        title: intl.formatMessage({ id: 'salesman' }),
        // sort field
        dataIndex: 'salesman_username',
        // filter field
        key: 'salesman',
        ...AntDesignTable.getColumnSearchInputProps(
          filters,
          intl.formatMessage({ id: 'salesman' }),
          'salesman',
          this.handleSearch,
          this.handleReset
        ),
        render: (text, record) => (
          <>
            <div>
              <b>{record.salesman.username}</b>
            </div>
          </>
        )
      },
      {
        width: 150,
        align: 'left',
        title: intl.formatMessage({ id: 'delivery_point' }),
        // sort field
        dataIndex: 'delivery_point_code',
        ...AntDesignTable.getColumnSortProps(sorts, 'delivery_point_code'),
        // filter field
        key: 'delivery_point',
        ...AntDesignTable.getColumnSearchInputProps(
          filters,
          intl.formatMessage({ id: 'delivery_point' }),
          'delivery_point',
          this.handleSearch,
          this.handleReset
        ),
        render: (text, record) => (
          <>
            <div>
              <b>{record.delivery_point.code}</b>
              <br />
              {record.delivery_point.company_name_01}
            </div>
          </>
        )
      },
      {
        width: 100,
        align: 'right',
        title: packListHdrCaseQty01,
        // sort field
        dataIndex: 'case_qty',
        ...AntDesignTable.getColumnSortProps(sorts, 'case_qty'),
        // filter field
        key: 'case_qty',
        render: (text, record) => (
          <>
            {new Intl.NumberFormat([], {
              style: 'decimal',
              minimumFractionDigits: process.env.REACT_APP_DECIMAL_SCALE,
              maximumFractionDigits: process.env.REACT_APP_DECIMAL_SCALE
            }).format(record.case_qty)}
          </>
        ),
        hidden: !packListHdrCaseQty01 || packListHdrCaseQty01.length <= 0
      },
      {
        width: 100,
        align: 'right',
        title: packListHdrCaseQty02,
        // sort field
        dataIndex: 'case_qty_02',
        ...AntDesignTable.getColumnSortProps(sorts, 'case_qty_02'),
        // filter field
        key: 'case_qty_02',
        render: (text, record) => (
          <>
            {new Intl.NumberFormat([], {
              style: 'decimal',
              minimumFractionDigits: process.env.REACT_APP_DECIMAL_SCALE,
              maximumFractionDigits: process.env.REACT_APP_DECIMAL_SCALE
            }).format(record.case_qty_02)}
          </>
        ),
        hidden: !packListHdrCaseQty02 || packListHdrCaseQty02.length <= 0
      },
      {
        width: 100,
        align: 'right',
        title: packListHdrCaseQty03,
        // sort field
        dataIndex: 'case_qty_03',
        ...AntDesignTable.getColumnSortProps(sorts, 'case_qty_03'),
        // filter field
        key: 'case_qty_03',
        render: (text, record) => (
          <>
            {new Intl.NumberFormat([], {
              style: 'decimal',
              minimumFractionDigits: process.env.REACT_APP_DECIMAL_SCALE,
              maximumFractionDigits: process.env.REACT_APP_DECIMAL_SCALE
            }).format(record.case_qty_03)}
          </>
        ),
        hidden: !packListHdrCaseQty03 || packListHdrCaseQty03.length <= 0
      },
      {
        width: 100,
        align: 'right',
        title: packListHdrCaseQty04,
        // sort field
        dataIndex: 'case_qty_04',
        ...AntDesignTable.getColumnSortProps(sorts, 'case_qty_04'),
        // filter field
        key: 'case_qty_04',
        render: (text, record) => (
          <>
            {new Intl.NumberFormat([], {
              style: 'decimal',
              minimumFractionDigits: process.env.REACT_APP_DECIMAL_SCALE,
              maximumFractionDigits: process.env.REACT_APP_DECIMAL_SCALE
            }).format(record.case_qty_04)}
          </>
        ),
        hidden: !packListHdrCaseQty04 || packListHdrCaseQty04.length <= 0
      },
      {
        width: 100,
        align: 'right',
        title: packListHdrCaseQty05,
        // sort field
        dataIndex: 'case_qty_05',
        ...AntDesignTable.getColumnSortProps(sorts, 'case_qty_05'),
        // filter field
        key: 'case_qty_05',
        render: (text, record) => (
          <>
            {new Intl.NumberFormat([], {
              style: 'decimal',
              minimumFractionDigits: process.env.REACT_APP_DECIMAL_SCALE,
              maximumFractionDigits: process.env.REACT_APP_DECIMAL_SCALE
            }).format(record.case_qty_05)}
          </>
        ),
        hidden: !packListHdrCaseQty05 || packListHdrCaseQty05.length <= 0
      },
      {
        width: 100,
        align: 'right',
        title: packListHdrCaseQty06,
        // sort field
        dataIndex: 'case_qty_06',
        ...AntDesignTable.getColumnSortProps(sorts, 'case_qty_06'),
        // filter field
        key: 'case_qty_06',
        render: (text, record) => (
          <>
            {new Intl.NumberFormat([], {
              style: 'decimal',
              minimumFractionDigits: process.env.REACT_APP_DECIMAL_SCALE,
              maximumFractionDigits: process.env.REACT_APP_DECIMAL_SCALE
            }).format(record.case_qty_06)}
          </>
        ),
        hidden: !packListHdrCaseQty06 || packListHdrCaseQty06.length <= 0
      },
      {
        width: 100,
        align: 'right',
        title: packListHdrCaseQty07,
        // sort field
        dataIndex: 'case_qty_07',
        ...AntDesignTable.getColumnSortProps(sorts, 'case_qty_07'),
        // filter field
        key: 'case_qty_07',
        render: (text, record) => (
          <>
            {new Intl.NumberFormat([], {
              style: 'decimal',
              minimumFractionDigits: process.env.REACT_APP_DECIMAL_SCALE,
              maximumFractionDigits: process.env.REACT_APP_DECIMAL_SCALE
            }).format(record.case_qty_07)}
          </>
        ),
        hidden: !packListHdrCaseQty07 || packListHdrCaseQty07.length <= 0
      },
      {
        width: 100,
        align: 'right',
        title: packListHdrCaseQty08,
        // sort field
        dataIndex: 'case_qty_08',
        ...AntDesignTable.getColumnSortProps(sorts, 'case_qty_08'),
        // filter field
        key: 'case_qty_08',
        render: (text, record) => (
          <>
            {new Intl.NumberFormat([], {
              style: 'decimal',
              minimumFractionDigits: process.env.REACT_APP_DECIMAL_SCALE,
              maximumFractionDigits: process.env.REACT_APP_DECIMAL_SCALE
            }).format(record.case_qty_08)}
          </>
        ),
        hidden: !packListHdrCaseQty08 || packListHdrCaseQty08.length <= 0
      },
      {
        width: 100,
        align: 'right',
        title: packListHdrCaseQty09,
        // sort field
        dataIndex: 'case_qty_09',
        ...AntDesignTable.getColumnSortProps(sorts, 'case_qty_09'),
        // filter field
        key: 'case_qty_09',
        render: (text, record) => (
          <>
            {new Intl.NumberFormat([], {
              style: 'decimal',
              minimumFractionDigits: process.env.REACT_APP_DECIMAL_SCALE,
              maximumFractionDigits: process.env.REACT_APP_DECIMAL_SCALE
            }).format(record.case_qty_09)}
          </>
        ),
        hidden: !packListHdrCaseQty09 || packListHdrCaseQty09.length <= 0
      },
      {
        width: 100,
        align: 'right',
        title: packListHdrCaseQty10,
        // sort field
        dataIndex: 'case_qty_10',
        ...AntDesignTable.getColumnSortProps(sorts, 'case_qty_10'),
        // filter field
        key: 'case_qty_10',
        render: (text, record) => (
          <>
            {new Intl.NumberFormat([], {
              style: 'decimal',
              minimumFractionDigits: process.env.REACT_APP_DECIMAL_SCALE,
              maximumFractionDigits: process.env.REACT_APP_DECIMAL_SCALE
            }).format(record.case_qty_10)}
          </>
        ),
        hidden: !packListHdrCaseQty10 || packListHdrCaseQty10.length <= 0
      },
      {
        width: 150,
        // fixed: 'right',
        align: 'left',
        title: intl.formatMessage({ id: 'documents' }),
        // sort field
        dataIndex: 'outb_ord_hdr_code',
        ...AntDesignTable.getColumnSortProps(sorts, 'outb_ord_hdr_code'),
        // filter field
        key: 'outb_ord_hdr',
        ...AntDesignTable.getColumnSearchInputProps(
          filters,
          intl.formatMessage({ id: 'documents' }),
          'outb_ord_hdr',
          this.handleSearch,
          this.handleReset
        ),
        render: (text, record) => (
          <>
            <div style={{ width: '100%', textAlign: 'right' }}>
              <div>
                <b>{record.outb_ord_hdr.shipping_doc_code}</b>
              </div>
              <div>
                <b>{record.outb_ord_hdr.ref_code_01}</b>
              </div>
              <div>
                {new Intl.NumberFormat([], {
                  style: 'decimal',
                  minimumFractionDigits: process.env.REACT_APP_DECIMAL_SCALE,
                  maximumFractionDigits: process.env.REACT_APP_DECIMAL_SCALE
                }).format(record.outb_ord_hdr.net_amt)}
              </div>
            </div>
          </>
        )
      },

      {
        width: 100,
        align: 'left',
        title: intl.formatMessage({ id: 'desc_01' }),
        // sort field
        dataIndex: 'desc_01',
        ...AntDesignTable.getColumnSortProps(sorts, 'desc_01'),
        // filter field
        key: 'desc_01',
        ...AntDesignTable.getColumnSearchInputProps(
          filters,
          intl.formatMessage({ id: 'desc_01' }),
          'desc_01',
          this.handleSearch,
          this.handleReset
        ),
        render: (text, record) => <>{record.desc_01}</>
      },
      {
        width: 100,
        align: 'left',
        title: intl.formatMessage({ id: 'desc_02' }),
        // sort field
        dataIndex: 'desc_02',
        ...AntDesignTable.getColumnSortProps(sorts, 'desc_02'),
        // filter field
        key: 'desc_02',
        ...AntDesignTable.getColumnSearchInputProps(
          filters,
          intl.formatMessage({ id: 'desc_02' }),
          'desc_02',
          this.handleSearch,
          this.handleReset
        ),
        render: (text, record) => <>{record.desc_02}</>
      },
      {
        width: 50,
        fixed: 'right',
        key: 'action',
        render: (text, record) => (
          <>
            <Popconfirm
              placement="left"
              title={intl.formatMessage({ id: 'are_you_sure_to_print' })}
              onConfirm={() => goToPrint(record)}
              onCancel={() => {}}
              okText={intl.formatMessage({ id: 'yes' })}
              cancelText={intl.formatMessage({ id: 'cancel' })}
              disabled={record.doc_status !== 100}
            >
              <Button
                type="dashed"
                icon={<PrinterOutlined />}
                disabled={record.doc_status !== 100}
              />
            </Popconfirm>
            <Popconfirm
              placement="left"
              title={intl.formatMessage({ id: 'are_you_sure_to_download' })}
              onConfirm={() => excelOutbOrdDtls(record)}
              onCancel={() => {}}
              okText={intl.formatMessage({ id: 'yes' })}
              cancelText={intl.formatMessage({ id: 'cancel' })}
              disabled={record.doc_status !== 100}
            >
              <Button
                type="dashed"
                icon={<DownloadOutlined />}
                disabled={record.doc_status !== 100}
              />
            </Popconfirm>
            <Button type="dashed" icon={<EditOutlined />} onClick={() => goToDocument(record.id)} />
            <Button type="dashed" icon={<AuditOutlined />} onClick={() => goToAudit(record.id)} />
          </>
        )
      }
    ].filter(column => {
      return !column.hidden;
    });
  }

  useOnTableChange(pagination, filters, sorter) {
    const { resetTimestamp } = this.props;

    const processedFilters = AntDesignTable.processFilters(filters);
    const processedSorts = AntDesignTable.processSorts(sorter);

    resetTimestamp(pagination.current, processedSorts, processedFilters, pagination.pageSize);
  }

  useShowWorkspace() {
    const { setWorkspaceVisible } = this.props;

    setWorkspaceVisible(true);
  }

  render() {
    const {
      intl,
      resetTimestamp,
      currentPage,
      pageSize,
      total,
      documents,
      fetchIsLoading,
      selectedDocuments,
      addSelectedDocuments,
      removeSelectedDocuments
    } = this.props;

    return (
      <Card
        title={intl.formatMessage({ id: 'pack_lists' })}
        bordered={false}
        headStyle={{ textAlign: 'center' }}
        bodyStyle={{ padding: 0 }}
      >
        <Table
          size="small"
          // rowSelection={rowSelection}
          rowKey="id"
          pagination={{
            current: currentPage,
            pageSize: parseInt(pageSize, 10),
            total,
            showTotal: () => `${total} items`
          }}
          columns={this.getDocumentColumns()}
          dataSource={documents}
          loading={fetchIsLoading}
          bordered
          rowSelection={{
            selectedRowKeys: selectedDocuments.map(value => value.id),
            onChange: () => {
              // console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
            },
            onSelect: (record, selected) => {
              // console.log(`onSelect record: `, record, 'selected: ', selected, 'selectedRows: ', selectedRows);
              if (selected === true) {
                addSelectedDocuments([record]);
              } else {
                removeSelectedDocuments([record]);
              }
            },
            onSelectAll: (selected, selectedRows, changeRows) => {
              // console.log('onSelectAll selected: ', selected, 'selectedRows: ', selectedRows, 'changeRows: ', changeRows);
              if (selected === true) {
                addSelectedDocuments(changeRows);
              } else {
                removeSelectedDocuments(changeRows);
              }
            },
            onSelectInvert: selectedRows => {
              // console.log('onSelectInvert selectedRows: ', selectedRows);
              removeSelectedDocuments(selectedRows);
            },
            getCheckboxProps: () => ({
              // Column configuration not to be checked
              // disabled: record.str_doc_status !== 'WIP'
              // name: record.name,
            })
          }}
          onChange={this.useOnTableChange}
          title={() => (
            <>
              <Row type="flex" justify="space-between" gutter={[0, 16]}>
                <Col span={8}>
                  <Button
                    type="primary"
                    // disabled={!isValid}
                    loading={fetchIsLoading}
                    onClick={() => resetTimestamp()}
                    icon={<ReloadOutlined />}
                  />
                </Col>
              </Row>
            </>
          )}
          scroll={{ x: 950 }}
        />
      </Card>
    );
  }
}

PackListIndexScreen.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  intl: PropTypes.object,
  resetTimestamp: PropTypes.func,
  goToDocument: PropTypes.func,
  goToPrint: PropTypes.func,
  excelOutbOrdDtls: PropTypes.func,
  goToAudit: PropTypes.func,

  setWorkspaceVisible: PropTypes.func,

  addSelectedDocuments: PropTypes.func,
  removeSelectedDocuments: PropTypes.func,
  documents: PropTypes.arrayOf(PropTypes.object),
  selectedDocuments: PropTypes.arrayOf(PropTypes.object),

  sorts: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.number, PropTypes.string])),
  filters: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.number, PropTypes.string])),

  currentPage: PropTypes.number,
  pageSize: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  total: PropTypes.number,
  fetchIsLoading: PropTypes.bool,

  curSiteFlowId: PropTypes.number,
  fetchPackListIndex: PropTypes.func
};

PackListIndexScreen.defaultProps = {
  intl: {},
  resetTimestamp() {},
  goToDocument() {},
  goToPrint() {},
  excelOutbOrdDtls() {},
  goToAudit() {},

  setWorkspaceVisible() {},

  addSelectedDocuments() {},
  removeSelectedDocuments() {},
  documents: [],
  selectedDocuments: [],

  sorts: {},
  filters: {},

  currentPage: 1,
  pageSize: '20',
  total: 0,
  fetchIsLoading: false,

  curSiteFlowId: 0,
  fetchPackListIndex() {}
};

const mapStateToProps = state => ({
  timestamp: state.packListIndex.timestamp,

  documents: state.packListIndex.documents,
  selectedDocuments: state.packListIndex.selectedDocuments,

  sorts: state.packListIndex.sorts,
  filters: state.packListIndex.filters,

  currentPage: state.packListIndex.currentPage,
  pageSize: state.packListIndex.pageSize,
  total: state.packListIndex.total,
  fetchIsLoading: state.packListIndex.fetchIsLoading,

  curSiteFlowId: state.app.curSiteFlowId
});

const mapDispatchToProps = dispatch => ({
  resetTimestamp: (currentPage, sorts, filters, pageSize) =>
    dispatch(
      PackListIndexActions.packListIndexResetTimestamp(currentPage, sorts, filters, pageSize)
    ),
  goToDocument: hdrId => dispatch(PackListIndexActions.packListIndexGoToDocument(hdrId)),
  goToPrint: document => dispatch(PackListIndexActions.packListIndexGoToPrint(document)),
  excelOutbOrdDtls: document =>
    dispatch(PackListIndexActions.packListIndexExcelOutbOrdDtls(document)),
  goToAudit: hdrId => dispatch(PackListIndexActions.packListIndexGoToAudit(hdrId)),

  setWorkspaceVisible: boolean =>
    dispatch(PackListIndexActions.packListIndexSetWorkspaceVisible(boolean)),

  addSelectedDocuments: selectedDocuments =>
    dispatch(PackListIndexActions.packListIndexAddSelectedDocuments(selectedDocuments)),
  removeSelectedDocuments: selectedDocuments =>
    dispatch(PackListIndexActions.packListIndexRemoveSelectedDocuments(selectedDocuments)),

  fetchPackListIndex: (currentPage, sorts, filters, pageSize) =>
    dispatch(
      PackListIndexActions.packListIndexFetchPackListIndex(currentPage, sorts, filters, pageSize)
    )
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(PackListIndexScreen));
